import { useActionDialogContext } from '../../Context/ActionDialogContext';
import UIStrings from '@/Utils/UIStrings';

function HireDialogHeader() {
    const { selectedCandidates } = useActionDialogContext();
    const { name } = selectedCandidates[0];

    return (
        <div className="text-foreground text-xl font-bold">
            <span>{`${UIStrings.HaveYouHired} `}</span>
            <span>{`${name}?`}</span>
        </div>
    );
}

export default HireDialogHeader;
